import { render, staticRenderFns } from "./ErrorPage.vue?vue&type=template&id=81099a78&scoped=true&"
var script = {}
import style0 from "./ErrorPage.vue?vue&type=style&index=0&id=81099a78&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81099a78",
  null
  
)

export default component.exports